/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryKey =
  (
    financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams["financialPersonId"],
    params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/editor",
        params: { financialPersonId: financialPersonId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryKey
  >;

export function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryOptions(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryKey(
      financialPersonId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500
    >,
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
    typeof queryKey
  >({
    enabled: !!financialPersonId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor(
        financialPersonId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna o plano com totais (transferência, matrícula, pago), telefones separados em DDI+número, descontos com empresa associada, cupom ativo e histórico, endereço de terceiro, cartão mascarado e valores de leitura calculados (mensal/total com descontos, cupom e pontualidade). Os enums do plano vêm com o texto traduzido na cultura da requisição: 'typeText', 'statusText' e 'paymentMethodText'. 404 quando o plano não existe ou a empresa do usuário difere da matrícula. Defaults de criação do legado (não há endpoint próprio): PaymentMethod=Billet, DDI +55, AutomaticGenerateInvoice=true. Migrado do legado IndividualPayment/FinancialPersonEdit GET (GetIndividualPayment). **(Requer Authorization para autenticação)**
 * @summary Retorna os dados completos do plano para o editor (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/editor}
 */
export function useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor<
  TData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryKey,
>(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryKey(
      financialPersonId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryOptions(
        financialPersonId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
